import { Platform } from 'react-native';

export const webOnly = (styles: { [property: string]: any }) => {
  return Platform.OS === 'web' ? styles : {};
};

export const transition = () => {
  return Platform.OS === 'web' ? { transition: 'all 250ms' } : {};
};
